import {ref} from 'vue';
import {icons as collection} from '@/shared/assets.js';

export const SiteMenu = ref([
	{path: '/', name: 'home', icon: collection.home.path, displayName: 'Главная'},
	{path: '/library/articles', name: 'academy', icon: collection.book.path, displayName: 'Статьи', gtm: 'left_menu_1_articles'},
	// { path: '/library/top', name: 'top', icon: collection.cube.path, displayName: "Подборки" },
	{path: '/career/vacancies', name: 'articles', icon: collection.file.path, displayName: 'Вакансии'},
	{path: '/academy/courses', name: 'academy', icon: collection.box.path, displayName: 'Академия'},
	{path: '/library/multimedia', name: 'video', icon: collection.desktop.path, displayName: 'Видео'},
	{path: '/library/tools', name: 'tools', icon: collection.wrench.path, displayName: 'Инструменты'},
	{path: '/events', name: 'afisha', icon: collection.graph_pie.path, displayName: 'Афиша'},
]);
